// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M4.5 7.5H11.5C12.6 7.5 13.5 8.4 13.5 9.5V12.5C13.5 13.6 12.6 14.5 11.5 14.5H4.5C3.4 14.5 2.5 13.6 2.5 12.5V9.5C2.5 8.4 3.4 7.5 4.5 7.5Z',
  'M5 7.5V4.8C5 3.14 6.34 1.8 8 1.8C9.66 1.8 11 3.14 11 4.8V7.5',
];
